import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { client_v2 } from "utils/api";
import { Modal } from "components";
import { Loader } from "components";

const ModalGdnLinePickerMissings = ({
  date,
  approver_decision,
  handleClose,
}) => {
  const {
    isLoading,
    isFetching,
    data = [],
  } = useQuery(
    ["gdn_line_picker_missings_by_date", date, approver_decision],
    () =>
      client_v2.get(
        `/stats/gdn_line_picker_missings_by_date?date=${date}&approver_decision=${approver_decision}`
      ),
    {
      select: ({ data }) => data,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );

  const is_loading = isLoading || isFetching;
  return (
    <Modal
      size="full no-padding"
      handleClose={handleClose}
      header={{
        title:
          approver_decision === "approved"
            ? "Potencjalne braki rozpatrzone pozytywnie"
            : "Potencjalne braki rozpatrzone negatywnie",
      }}
    >
      {is_loading ? (
        <div className="p-t-10 p-b-10">
          <Loader />
        </div>
      ) : (
        data?.length > 0 && (
          <table class="table table-sm">
            <thead class="table__header">
              <tr>
                <th>SKU</th>
                <th>Piker</th>
                <th>Os. sprawdzająca</th>
                <th>Data zgłoszenia</th>
                <th>Data weryfikacji</th>
                <th>Rezultat</th>
                <th>Ilość pozycji zgłoszonych przez pakera / pikera</th>
              </tr>
            </thead>
            <tbody class="table__body">
              {data.map(
                ({
                  picker_name,
                  approver_name,
                  approved_at,
                  created_at,
                  product_sku,
                  approver_decision,
                  gdn_lines_potentially_missing_count,
                  gdn_lines_marked_as_missing_count,
                }) => (
                  <tr className="table-row">
                    <td>{product_sku}</td>
                    <td>{picker_name}</td>
                    <td>{approver_name}</td>
                    <td>
                      {created_at
                        ? moment(created_at).format("YYYY-MM-DD HH:mm")
                        : "-"}
                    </td>
                    <td>
                      {approved_at
                        ? moment(approved_at).format("YYYY-MM-DD HH:mm")
                        : "-"}
                    </td>
                    <td>
                      {approver_decision === "declined"
                        ? "Odrzucono"
                        : approver_decision === "approved"
                        ? "Potwierdzono"
                        : "Brak decyzji"}
                    </td>
                    <td>{`${gdn_lines_marked_as_missing_count}/${gdn_lines_potentially_missing_count}`}</td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        )
      )}
    </Modal>
  );
};
export default ModalGdnLinePickerMissings;
